import React from 'react';
import { useRecoilStateLoadable } from 'recoil';
import { smsMetric } from '../../../recoil/atoms/smsMetric';
import { FormControl, InputLabel, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles((theme) => ({
  metricDropdown: {
    marginLeft: '1vw',
    marginTop: '10px',
  },
}));
export function SmsMetricDropdown() {
  const classes = useStyles();
  const [metric, setMetric] = useRecoilStateLoadable(smsMetric);

  function metricHandler(e) {
    setMetric(e.target.value);
  }
  const groupTypes = ['Total', 'Incoming', 'Outgoing'];
  return (
    <FormControl
      className={classes.metricDropdown}
      size="small"
      variant="outlined"
    >
      <InputLabel>Metric</InputLabel>
      <Select
        defaultValue={metric.contents}
        native
        onChange={metricHandler}
        label="Metric"
        name="sms-metric-dropdown"
      >
        {groupTypes.map((group) => (
          <option key={group} value={group}>
            {group}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}
